
export class Advice {
  constructor() {
    this.id = 0;
    this.adviceName = "";
    this.adviceOnTicket = "";
  }
}